import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";

import PlayerList from "../components/PlayerManagement/PlayerList";
import useRefresh from "../components/Refresh/refresh";
import DashboardTabs from "../components/ui/DashboardTabs";
import getProMapping from "../components/Signups/getProMapping";
import PRO_COLORS from "./proColors";
import HorseRequestsManager from "src/components/HorseManagement/HorseRequestsManager";
import { Button, Card, CardContent, Stack, Snackbar, Alert } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

function LessonSignupPage({
  eventId,
  clubId,
  gameDate,
  devPort,
  waiverNotifications,
  managerMode,
  userName,
}) {
  const [players, setPlayers] = useState([]);
  const [loadingSignups, setLoadingSignups] = useState(true);
  const [proColorMapping, setProColorMapping] = useState();
  const [managerUserId, setManagerUserId] = useState(null);
  const [horseRequestsRefreshTrigger] = useState(0);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  console.log("TEEEEEESSST LESSONS " + eventId);
  let navigate = useNavigate();
  useRefresh(clubId, devPort);
  console.log("Lesson Event" + eventId);

  // Fetch manager's user ID for horse assignment
  useEffect(() => {
    if (managerMode === -1 && userName) {
      fetch(devPort + "system_get_manager/" + userName, {
        credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data[0] && data[0][0]) {
            setManagerUserId(String(data[0][0]));
          }
        })
        .catch(() => {});
    }
  }, [devPort, userName, managerMode]);
  const loadPlayers = useCallback(() => {
    console.log(devPort + "student_roster/" + clubId + "/" + eventId);
    fetch(devPort + "student_roster/" + clubId + "/" + eventId, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let formattedData = [];
        let colorIndex = 0;
        let newProColorMapping = {};
        console.log("DATA WAIVERS");
        console.log(data);
        data.map((player) => {
          // Parse horse assignments from JSON (index 10)
          let horseAssignments = [];
          if (player[10]) {
            try {
              horseAssignments = typeof player[10] === 'string' 
                ? JSON.parse(player[10]) 
                : player[10];
              if (!Array.isArray(horseAssignments)) {
                horseAssignments = [];
              }
            } catch (e) {
              console.error("Failed to parse horse assignments:", e);
              horseAssignments = [];
            }
          }
          formattedData.push({
            player_id: player[0],
            first_name: player[1],
            last_name: player[2],
            uspa_rating: player[3],
            club_rating: player[4],
            lesson_id: player[5],
            signup_notes: player[6],
            paid_lesson: player[7],
            coach: player[8],
            up_to_date_waiver: player[9],
            horse_assignments: horseAssignments,
          });
          if (player[8] && !newProColorMapping[player[8]]) {
            newProColorMapping[player[8]] = PRO_COLORS[colorIndex];
            if (colorIndex === PRO_COLORS.length - 1) {
              colorIndex = 0;
            } else {
              colorIndex += 1;
            }
          }
          return null;
        });
        console.log("OUTPUT DATA");
        console.log(formattedData);
        setProColorMapping(newProColorMapping);
        setPlayers(formattedData);
        setLoadingSignups(false);
      });
  }, [devPort, clubId, eventId]);

  // Update horse assignments for a specific player locally (no re-fetch)
  const updatePlayerAssignments = useCallback((playerId, newAssignments) => {
    setPlayers(prevPlayers => 
      prevPlayers.map(player => 
        String(player.player_id) === String(playerId)
          ? { ...player, horse_assignments: newAssignments }
          : player
      )
    );
    // Note: We don't trigger HorseRequestsManager refresh here to avoid flash/reload.
    // HorseRequestsManager updates its own state when its modal is used.
  }, []);
  useEffect(() => {
    loadPlayers();
  }, [loadPlayers]);
  function deletePlayer(playerId) {
    fetch(devPort + "delete_lesson_signup/" + eventId + "/" + playerId, {
      method: "POST",
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        loadPlayers();
      });
  }
  let currentPage = "/lessonsignup";
  const [proMapping, setProMapping] = useState();
  useEffect(() => {
    loadPlayers();
    const player_fetcher = devPort + "player_list/" + clubId + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
  }, [devPort, clubId, loadPlayers]);

  const handleSendLessonEmail = () => {
    setSendingEmail(true);
    fetch(devPort + "email_lesson_details", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        clubId: clubId,
        lessonId: eventId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setSendingEmail(false);
        if (data.error) {
          setSnackbar({
            open: true,
            message: `Failed to send emails: ${data.error}`,
            severity: "error",
          });
        } else {
          setSnackbar({
            open: true,
            message: `Lesson emails sent successfully to ${data.total_sent} recipient(s)`,
            severity: "success",
          });
        }
      })
      .catch((error) => {
        setSendingEmail(false);
        setSnackbar({
          open: true,
          message: "Failed to send lesson emails",
          severity: "error",
        });
      });
  };

  return (
    <Layout managerMode={managerMode} waiverNotifications={waiverNotifications} devPort={devPort}>
      <DashboardTabs
        currentPage={currentPage}
        managerMode={managerMode}
        gameMode="lesson"
      />
      {/* Email Button for Managers */}
      {managerMode === -1 && eventId && (
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack>
                <h3 style={{ margin: 0 }}>Send Lesson Confirmation Emails</h3>
                <p style={{ margin: "8px 0 0 0", color: "#666", fontSize: "14px" }}>
                  Send lesson details, player list, and horse assignments to all participants and the manager
                </p>
              </Stack>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EmailIcon />}
                onClick={handleSendLessonEmail}
                disabled={sendingEmail}
                sx={{ minWidth: 180 }}
              >
                {sendingEmail ? "Sending..." : "Send Emails"}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      )}
      {/* Horse Requests Manager for managers to see and assign horses */}
      {managerMode === -1 && eventId && (
        <HorseRequestsManager
          devPort={devPort}
          clubId={clubId}
          eventType="lessons"
          eventId={eventId}
          managerMode={managerMode}
          updatePlayerAssignments={updatePlayerAssignments}
          refreshTrigger={horseRequestsRefreshTrigger}
          externalAssignments={!loadingSignups && players.length > 0 ? players.flatMap(p => p.horse_assignments || []) : undefined}
        />
      )}
      <section>
        <PlayerList
          devPort={devPort}
          loadingPage={loadingSignups}
          managerMode={managerMode}
          title={"Signups for Lesson on " + gameDate}
          clubId={clubId}
          gameId={eventId}
          players={players}
          nameEdit={false}
          ratingEdit={false}
          chukkerEdit={true}
          refresh={loadPlayers}
          playerDelete={deletePlayer}
          addPlayer={() => navigate("/addLessonplayer")}
          proColorMapping={proColorMapping}
          gameMode="lesson"
          tableMode="lessons"
          proMapping={proMapping}
          updatePlayerAssignments={updatePlayerAssignments}
          managerUserId={managerUserId}
        />
      </section>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Layout>
  );
}

export default LessonSignupPage;
